/**
 * How much room the app has, as semantic answers.
 *
 * The two breakpoints are the design system's (`tokens.layout` in LaunchPad/ideas/_design.md) and
 * arrive here through the generated token file. **This is the only place in the client where those
 * pixel values may appear** — a screen that compares against a number has taken a dependency on a
 * decision the design file owns, and the fleet rule is that width decides layout while platform
 * decides quirks.
 *
 *   wide      the side rail replaces the bottom bar; screens may split into panes
 *   expanded  room for a third region — wider gutters, more metadata per row
 */
import { useWindowDimensions } from 'react-native';
import { breakpoints } from '../design-tokens';

export interface Layout {
  wide: boolean;
  expanded: boolean;
}

export function useLayout(): Layout {
  const { width } = useWindowDimensions();
  return { wide: width >= breakpoints.wide, expanded: width >= breakpoints.expanded };
}
